function Contact() {
  return (
    <div className="section">
      <h2>Contact Us</h2>

      <div className="grid">
        <div className="card">
          <h3>Call Us</h3>
          <p><strong>Mobile:</strong> 7733982109</p>
          <p><strong>Alternate:</strong> 9911649334</p>
          <p>Business Hours: 9 AM – 7 PM</p>
        </div>

        <div className="card">
          <h3>Visit Us</h3>
          <p>
            Rasoolpur Nawada <br />
            Shop No. 15, Yadav Market <br />
            Near Powerhouse <br />
            Noida Sec 62, 201301 <br />
            Uttar Pradesh
          </p>
        </div>

        <div className="card">
          <h3>Wholesale Enquiries</h3>
          <p>
            For bulk dairy & frozen product orders,
            connect directly via WhatsApp.
          </p>

          <a
            href="https://wa.me/917733982109?text=Hello%20I%20am%20interested%20in%20your%20wholesale%20products"
            className="btn"
            target="_blank"
            rel="noopener noreferrer"
          >
            Enquire on WhatsApp
          </a>
        </div>
      </div>
    </div>
  );
}

export default Contact;